import { IsNotEmpty, IsString } from 'class-validator';

export class CreateRecipeCategoryDto {
  @IsString()
  @IsNotEmpty()
  name!: string;
}

export class UpdateRecipeCategoryDto {
  @IsString()
  @IsNotEmpty()
  name!: string;
}
